import axios from "axios";
import router from "../router";
import store from "../store";
import { notification } from "ant-design-vue";
import { loadProgressBar } from "axios-progress-bar";
import i18n from "../i18n";
import { state as stateApp } from "../app.logic";

const request = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

loadProgressBar({ showSpinner: false }, request);

request.interceptors.request.use(
    (config) => {
        if (!config.params) {
            config.params = {};
        }
        const urlQueryParams = getUrlVars(config.url);
        config.params = {
            ...config.params,
            ...urlQueryParams,
        };
        const isAuth = store.getters[`resource/auth/isAuth`];
        if (isAuth) {
            config.headers["Authorization"] = "Bearer " + store.getters[`resource/auth/getToken`];
            store.dispatch("resource/auth/setIntervalLogout", {});
        }
        if (stateApp.menuContext) {
            config.headers["C-Menu"] = stateApp.menuContext.refMenu.id;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

request.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        const config = error.config;
        const response = error.response;
        if (!response) {
            router.push({ name: "500" });
        } else if (!config.isNotification) {
            let message = response.data?.message;
            const errorCode = response.data?.data?.messageKey;
            if (errorCode && i18n.global.te(errorCode)) {
                message = i18n.global.t(errorCode, { ...response.data?.data });
            }
            if (!message) {
                message = `${response.status} ${response.statusText}`;
            }
            notification["error"]({ message, duration: 15 });
        }
        return Promise.reject(error);
    }
);

function getUrlVars(url) {
    var vars = {};
    url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
        vars[key] = value;
    });
    return vars;
}

export default request;
